import { types as t } from 'mobx-state-tree';

import { ReadingTestSection } from '../../../question-data-model/TestSection/_implementations/reading-test-section.store';
import { ViewTestSubjectTestSectionStore } from '../test-section.store';

export const ViewTestSubjectReadingTestSection = t
  .compose(ReadingTestSection, ViewTestSubjectTestSectionStore)
  .named('ViewTestSubjectReadingTestSection')
  .views((self) => ({
    getTableOfContentForPracticeTest() {
      return [
        {
          id: 'test-section-1',
          prefix: '📖 ',
          text: 'Bài đọc (reading passage)',
        },
        {
          id: 'question-passage-1',
          prefix: '❓ ',
          text: 'Câu hỏi (questions)',
        },
        {
          id: `solution-passage-1`,
          prefix: '🔥 ',
          text: `Answer key (đáp án và giải thích)`,
        },
      ];
    },
    getTableOfContent(testSectionIndex) {
      const index = testSectionIndex + 1;
      return [
        {
          id: `passage-${index}`,
          text: `Passage & question & answer key reading passage ${index}`,
          prefix: undefined,
          sub: [
            {
              id: `test-section-${index}`,
              prefix: '📖 ',
              text: `Bài đọc passage ${index}`,
            },
            {
              id: `question-passage-${index}`,
              prefix: '❓ ',
              text: `Câu hỏi passage ${index}`,
            },
            {
              id: `solution-passage-${index}`,
              prefix: '🔥 ',
              text: `Đáp án & giải thích ${index}`,
            },
          ],
        },
      ];
    },
  }));
